import { useAtomValue } from 'jotai';
import {
    BulletList,
    Card,
    Exercise,
    LabelBody,
    LabelBodyHeadline,
    LabelDisplay1,
    LabelDisplay2,
    LabelTelescope,
    SecondaryButton,
    Spacer,
    Textarea,
} from '../../components';
import { exercisesAtom } from '../../data';
import { IllustrationWeightLifter } from '../../icons';
import { ExerciseStatus } from '../../interfaces';
import {
    normalizeInput,
    parseArray,
    useSyncedState,
} from '../../useSyncedState';
import { ExerciseData, ExerciseViewProps } from '../exercises';
import { exercise222Page2TextKey } from './Module2S2Exercise2';
import { createQuestionFromConfiguration } from '../../../logbook/views/QuestionView';

const goalKey = 'exercise222GoalKey';

export const exerciseData222Goal: ExerciseData = {
    ExerciseView: Module2S2ExerciseGoal,
    dataKeys: [goalKey],
    questions: [
        createQuestionFromConfiguration({
            dataKeys: [goalKey],
            title: 'Din liste over selvomsorg',
            description:
                'Du kan øve dig i selvomsorg ved at få prioriteret tid til det, der gør dig godt.',
        }),
    ],
};

export function Module2S2ExerciseGoal({
    exercise,
    onContinue,
}: ExerciseViewProps) {
    const exercises = useAtomValue(exercisesAtom);
    const [goalInput, setGoalInput] = useSyncedState(
        exercise.Data[goalKey] ?? '',
    );
    const exercise222Page2TextInput: string[] = parseArray(
        exercises.find((x) => x.Code == '2.2.2')?.Data[exercise222Page2TextKey],
    );

    return (
        <Exercise title="Målsætning">
            <LabelDisplay2>Sæt dig et mål</LabelDisplay2>
            <LabelBody class="my-10">
                Du kan øve dig i selvomsorg ved at få prioriteret tid til det,
                der gør dig godt.
            </LabelBody>
            <IllustrationWeightLifter className="mx-auto my-30" />
            <Card>
                <LabelDisplay1>Skriv din målsætning</LabelDisplay1>
                <LabelBody class="mt-10">
                    <BulletList
                        items={[
                            'Vælg noget fra din egen liste over selvomsorg',
                            'Sæt dig et mål om, hvornår og hvor ofte du vil gøre den valgte ting på listen',
                        ]}
                    />
                </LabelBody>
                {exercise222Page2TextInput.length > 0 && (
                    <>
                        <LabelBodyHeadline
                            color="text-dark-red"
                            class="mb-10 mt-30"
                        >
                            Din liste over selvomsorg
                        </LabelBodyHeadline>
                        <LabelTelescope>
                            {exercise222Page2TextInput.map(
                                (item: string, index: number) => (
                                    <p key={index}>{item}</p>
                                ),
                            )}
                        </LabelTelescope>
                    </>
                )}
                <Textarea text={goalInput} onChangeText={setGoalInput} />
                <LabelBody>
                    Dit svar bliver gemt i logbogen, når du fortsætter.
                </LabelBody>
            </Card>
            <Spacer class="mt-30" />
            <SecondaryButton
                onClick={() =>
                    onContinue({
                        status: ExerciseStatus.Completed,
                        goToNext: false,
                        data: {
                            [goalKey]: normalizeInput(goalInput),
                        },
                    })
                }
            >
                Gem i logbogen
            </SecondaryButton>
        </Exercise>
    );
}
